export const inr = (v) =>
  `₹${(Number(v) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export const rs = (v) =>
  `Rs. ${(Number(v) || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

export const calculateDaysOld = (createdAt) => {
  const diffTime = Math.abs(new Date() - new Date(createdAt));
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};
